module.exports = __webpack_public_path__ + "static/media/video_shap.4f64f350.png";